import { render, staticRenderFns } from "./GoogleOAuthButton.vue?vue&type=template&id=926b8056&"
import script from "./GoogleOAuthButton.vue?vue&type=script&lang=js&"
export * from "./GoogleOAuthButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\Cam\\projects\\netcountable-app\\truple\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('926b8056')) {
      api.createRecord('926b8056', component.options)
    } else {
      api.reload('926b8056', component.options)
    }
    module.hot.accept("./GoogleOAuthButton.vue?vue&type=template&id=926b8056&", function () {
      api.rerender('926b8056', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/amplify/GoogleOAuthButton.vue"
export default component.exports